import { zodResolver } from "@hookform/resolvers/zod";
import { useToast } from "@medimo/ui";
import { updatePassword } from "aws-amplify/auth";
import { useForm } from "react-hook-form";
import { z } from "zod";

const ChangePassworFormSchema = z
  .object({
    oldPassword: z.string().min(1, {
      message: "現在のパスワードを入力してください",
    }),
    newPassword: z
      .string()
      .min(13, {
        message:
          "パスワードは13文字以上で、英大文字・英小文字・数字・記号をすべて含めてください。",
      })
      .regex(/[0-9]+/, { message: "数字を1文字以上使用してください" })
      .regex(/[a-z]+/, { message: "小文字を1文字以上使用してください" })
      .regex(/[A-Z]+/, { message: "大文字を1文字以上使用してください" })
      .regex(/[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]+/, {
        message:
          "記号（^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ ` = + -）を1文字以上使用してください",
      })
      .refine((val) => val === val.trim(), {
        message: "先頭または末尾にスペースは使用できません。",
      }),
    confirmPassword: z.string().min(1, {
      message: "新しいパスワードを再入力してください",
    }),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "パスワードが一致しません",
    path: ["confirmPassword"],
  });

type ChangePassworFormSchemaType = z.infer<typeof ChangePassworFormSchema>;

export const useChangePasswordForm = ({
  onSubmitSuccessful,
}: {
  onSubmitSuccessful: VoidFunction;
}) => {
  const form = useForm<ChangePassworFormSchemaType>({
    resolver: zodResolver(ChangePassworFormSchema),
    defaultValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    mode: "onChange",
  });

  const { toast } = useToast();
  const onSubmit = async (values: ChangePassworFormSchemaType) => {
    try {
      const { newPassword, oldPassword } = values;
      await updatePassword({
        newPassword,
        oldPassword,
      });
      onSubmitSuccessful();
      toast({
        title: "パスワードの更新に成功しました",
      });
    } catch (_) {
      toast({
        title: "パスワードの更新に失敗しました",
        variant: "destructive",
      });
    }
  };
  return {
    form,
    onSubmit,
  };
};
